import { ApiUserProfile, UserProfile } from "./types";

/**
 * Maps an API user profile to a client user profile
 * @param apiProfile API user profile object
 * @returns Client user profile object
 */
export function mapApiUserProfile(apiProfile: ApiUserProfile): UserProfile {
  return {
    id: apiProfile.id,
    username: apiProfile.username,
    name: apiProfile.name ?? apiProfile.username ?? "",
    email: apiProfile.email,
    isStaff: apiProfile.is_staff,
    isActive: apiProfile.is_active,
    isSuperuser: apiProfile.is_superuser,
    isIfm: apiProfile.is_ifm,
    isSupplier: apiProfile.is_supplier,
    dateJoined: apiProfile.date_joined,
    groups: apiProfile.groups,
    featureFlags: apiProfile.feature_flags ?? {},
    organization: {
      id: apiProfile.organization.id,
      name: apiProfile.organization.name,
      subDomain: apiProfile.organization.sub_domain,
      organizationTypes: apiProfile.organization.organization_types,
    },
    magicbellKey: apiProfile.magicbell_key,
    magicbellExternalId: apiProfile.magicbell_external_id ?? null,
    magicbellExternalKey: apiProfile.magicbell_external_key ?? null,
    isTosAccepted: apiProfile.is_tos_accepted,
  };
}
